export default __webpack_public_path__ + "static/media/filter.8373056e.svg";